import { useState } from "react";

const services = [
  {
    id: 1,
    icon: "ri-test-tube-line",
    title: "THÍ NGHIỆM XI MĂNG",
    subtitle: "Cơ lý, Hóa xi măng",
    color: "from-[#0E5C3A] to-[#1A7A4E]",
    image: "https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/93d7ca282dc3e71333cb0c5177d84a3f.png",
    items: [
      "Xác định độ mịn, khối lượng riêng",
      "Xác định giới hạn bền uốn và nén",
      "Độ dẻo tiêu chuẩn, thời gian đông kết",
      "Tính ổn định thể tích, độ no sunfát",
      "Hàm lượng SO₃, cặn không tan",
      "Hàm lượng mất khi nung",
    ],
  },
  {
    id: 2,
    icon: "ri-building-4-line",
    title: "THÍ NGHIỆM BÊ TÔNG",
    subtitle: "Hỗn hợp bê tông và bê tông nặng",
    color: "from-[#4A2E00] to-[#7A5200]",
    image: "https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/3eb2805acce1ac95fba07591ed6a01a8.png",
    items: [
      "Xác định độ sụt hỗn hợp bê tông",
      "Xác định độ tách nước, tách vữa",
      "Giới hạn bền nén, bền kéo khi uốn",
      "Xác định độ chống thấm, độ co",
      "Xác định độ mài mòn, độ hút nước",
      "Bê tông tự lèn (SCC): độ chảy loang",
    ],
  },
  {
    id: 3,
    icon: "ri-stack-line",
    title: "THÍ NGHIỆM CỐT LIỆU",
    subtitle: "Cốt liệu dùng cho bê tông và vữa",
    color: "from-[#5C3A0E] to-[#8A5A1A]",
    image: "https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/852431c013a41711365379fcfa98893e.png",
    items: [
      "Thành phần cỡ hạt, hạt nhỏ hơn 75µm",
      "Khối lượng riêng, độ hút nước",
      "Hàm lượng bùn, bụi, sét",
      "Độ nén dập, Los Angeles",
      "Phản ứng kiềm silíc",
      "Hàm lượng clorua, hạt thoi dẹt",
    ],
  },
  {
    id: 4,
    icon: "ri-landscape-line",
    title: "THÍ NGHIỆM ĐẤT",
    subtitle: "Cơ lý đất trong phòng",
    color: "from-[#3A1A00] to-[#6B3A0E]",
    image: "https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/90e8bc250dd8f5353539bd99824491c7.png",
    items: [
      "Khối lượng riêng, độ ẩm, độ hút ẩm",
      "Giới hạn dẻo, giới hạn chảy",
      "Thành phần cỡ hạt",
      "Độ chặt tiêu chuẩn, đất đầm",
      "Sức chịu tải CBR đất, đá dăm",
      "Hàm lượng muối trong đất",
    ],
  },
  {
    id: 5,
    icon: "ri-links-line",
    title: "THÍ NGHIỆM KIM LOẠI",
    subtitle: "Thép, mối hàn, cáp dự ứng lực, kết cấu thép",
    color: "from-[#2C2C2C] to-[#555555]",
    image: "https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/0f3caf150cc651b6bb02019616016112.png",
    items: [
      "Thử kéo, thử uốn kim loại",
      "Kiểm tra mối hàn – siêu âm, hạt từ",
      "Thử kéo cáp dự ứng lực",
      "Độ cứng Brinell, Rockwell, Vickers",
      "Chiều dày lớp mạ, lớp phủ kẽm",
      "Thử cáp, bu lông, đai ốc",
    ],
  },
];

export default function ServicesSection() {
  const [active, setActive] = useState(0);
  const svc = services[active];

  return (
    <section id="services" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10 gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-[#0E5C3A] text-sm font-semibold uppercase tracking-widest mb-3">
              <i className="ri-flask-line"></i>
              Dịch vụ thí nghiệm
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800">
              CÁC DỊCH VỤ <span className="text-[#0E5C3A]">CHUYÊN NGÀNH</span>
            </h2>
            <div className="w-16 h-1 bg-[#D4A017] mt-3 rounded-full"></div>
          </div>
          <p className="text-gray-500 text-sm max-w-sm leading-relaxed">
            Thực hiện theo tiêu chuẩn TCVN và 22 TCN hiện hành với thiết bị hiện đại và đội ngũ kỹ thuật viên có kinh nghiệm.
          </p>
        </div>

        {/* Tab buttons */}
        <div className="flex flex-wrap gap-2 mb-6">
          {services.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`flex items-center gap-2 px-3 py-2 rounded-md text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                active === i
                  ? "bg-[#0E5C3A] text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              <i className={`${s.icon}`}></i>
              {s.title}
            </button>
          ))}
        </div>

        {/* Active service detail */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-xl overflow-hidden border border-gray-100">
          {/* Image */}
          <div className="relative h-56 md:h-72 lg:h-auto min-h-[260px]">
            <img
              src={svc.image}
              alt={svc.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-5 left-5 text-white">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className={`${svc.icon} text-lg`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold">{svc.title}</h3>
              <p className="text-white/80 text-xs mt-1">{svc.subtitle}</p>
            </div>
          </div>

          {/* Content */}
          <div className="bg-[#F5F7F2] p-5 md:p-7">
            <h4 className="text-base font-bold text-gray-800 mb-1">Các thí nghiệm thực hiện</h4>
            <p className="text-gray-500 text-xs mb-4">Danh mục thí nghiệm đại diện trong nhóm này:</p>
            <ul className="space-y-2.5">
              {svc.items.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center text-[#0E5C3A] shrink-0 mt-0.5">
                    <i className="ri-check-line text-sm font-bold"></i>
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => {
                const el = document.querySelector("#contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-6 inline-flex items-center gap-2 bg-[#0E5C3A] text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-[#0A4A2E] transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              Yêu cầu báo giá
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
